import { CustomCellRendererProps } from "ag-grid-react";
import { makeStyles } from "@material-ui/core";
import { ConsultantRowData } from "../../../utils/consultant-row-data";
import { WithCopyToClipboard } from "@common";

export const EmailRenderer = (props: CustomCellRendererProps<ConsultantRowData>) => {
  const classes = useStyles();

  if (!props.data?.Email && !props.data?.secondaryEmail) {
    return null;
  }

  return (
    <div className={classes.root}>
      {props.data?.Email && (
        <WithCopyToClipboard contentToCopy={props.data.Email}>
          <span>
            <a href={`mailto:${props.data.Email}`} className={classes.link}>
              {props.data.Email}
            </a>
          </span>
        </WithCopyToClipboard>
      )}

      {props.data?.secondaryEmail && (
        <WithCopyToClipboard contentToCopy={props.data.secondaryEmail}>
          <span>
            <a href={`mailto:${props.data.secondaryEmail}`} className={classes.link}>
              {props.data.secondaryEmail}
            </a>
          </span>
        </WithCopyToClipboard>
      )}
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column"
  },
  link: {
    color: theme.palette.primary.main
  }
}));
